import { isRTL } from "src/utils/global";
import classes from "./styles.module.css";
import logo from 'src/assets/images/logo.png';

interface LoadingPageProp {
    styles?: { [key: string]: string }
    extraClasses?: string
}

const LoadingPage = () => {
    return (
        <div className={classes.spinner__con}>
            <img src={logo} alt={"EL-ENTISAR AL ZAHER"} />
        </div>
    )
}

export default LoadingPage;